module.exports = __webpack_public_path__ + "img/p12.aefb08da.png";